import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { UserManagement } from './user-management.model';
import {UserTypeInum} from "../institution/institution-admin/institution-admin.model";

export const loadUserManagements = createAction(
  '[UserManagement/API] Load UserManagements',
  props<{ userManagements: UserManagement[] }>()
);

export const addUserManagement = createAction(
  '[UserManagement/API] Add UserManagement',
  props<{ userManagement: UserManagement }>()
);

export const upsertUserManagement = createAction(
  '[UserManagement/API] Upsert UserManagement',
  props<{ userManagement: UserManagement }>()
);

export const addUserManagements = createAction(
  '[UserManagement/API] Add UserManagements',
  props<{ userManagements: UserManagement[] }>()
);

export const upsertUserManagements = createAction(
  '[UserManagement/API] Upsert UserManagements',
  props<{ userManagements: UserManagement[] }>()
);

export const updateUserManagement = createAction(
  '[UserManagement/API] Update UserManagement',
  props<{ userManagement: Update<UserManagement> }>()
);

export const updateUserManagements = createAction(
  '[UserManagement/API] Update UserManagements',
  props<{ userManagements: Update<UserManagement>[] }>()
);

export const deleteUserManagement = createAction(
  '[UserManagement/API] Delete UserManagement',
  props<{ id: string }>()
);

export const deleteUserManagements = createAction(
  '[UserManagement/API] Delete UserManagements',
  props<{ ids: string[] }>()
);

export const clearUserManagements = createAction(
  '[UserManagement/API] Clear UserManagements'
);


export const getSystemAdministrators = createAction(
  '[UserManagement/API] Get SystemAdministrators',
  props<{ filtering: {
      profileType: UserTypeInum
    } }>()
)

export const createPopsmUsers = createAction(
  '[UserManagement/API] Create PopsmUsers',
  props<{ input: any }>()
)

export const updatePopsmUsers = createAction(
  '[UserManagement/API] Update PopsmUsers',
  props<{ input: any }>()
)
